// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.positionFixedBottom {
  position: fixed;
  bottom: 0;
  left: 0;
  /* width: 25vw; */
  max-height: 70vh;
  background-color: white;
  border-radius: 0 5% 0 0;
  overflow-y: scroll;
  box-shadow: 5px 5px 5px 5px rgba(0, 0, 0, 0.2);
}
.positionFixedBottom::-webkit-scrollbar {
  width: 20px;
}

.positionFixedBottom::-webkit-scrollbar-track {
  background-color: transparent;
}

.positionFixedBottom::-webkit-scrollbar-thumb {
  background-color: #d6dee1;
  border-radius: 20px;
  border: 6px solid transparent;
  background-clip: content-box;
}
.marcadorLateral {
  min-width: 70px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.tituloProduto {
  font-family: "Nunito";
  font-style: Medium;
  font-weight: 500;
  font-size: 11px;
  display: flex;
  color: #343a40;
}
.fonteDistancia {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;

  color: #6c6e6f;
}
.tituloLateral {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 13px;

  color: #343a40;
}
.tituloRecargaDisponivel {
  font-family: "Nunito";
  font-style: SemiBold;
  font-weight: 600;
  font-size: 12px;

  color: #343a40;
}
.textoEndereco {
  font-family: "Nunito";
  font-style: SemiBold;
  font-weight: 600;
  font-size: 12px;
  padding-top: 5px;
  color: #343a40;
}
#comoChegar {
  background-color: #ff6600;
  color: #fff;
  font-family: "Nunito";
  font-style: Medium;
}
#voltar {
  background-color: #cdcdc1;
  color: #343a40;
  font-family: "Nunito";
  font-style: Medium;
}

#detalhesLojas {
  overflow-y: scroll;
  max-height: 100px;
}

#detalhesLojas::-webkit-scrollbar {
  width: 20px;
}

#detalhesLojas::-webkit-scrollbar-track {
  background-color: transparent;
}

#detalhesLojas::-webkit-scrollbar-thumb {
  background-color: #d6dee1;
  border-radius: 20px;
  border: 6px solid transparent;
  background-clip: content-box;
}
`, "",{"version":3,"sources":["webpack://./src/Views/Mapa/filtroLateral/style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,8CAA8C;AAChD;AACA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;;EAEf,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;;EAEf,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;;EAEf,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;AAC9B","sourcesContent":[".positionFixedBottom {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  /* width: 25vw; */\n  max-height: 70vh;\n  background-color: white;\n  border-radius: 0 5% 0 0;\n  overflow-y: scroll;\n  box-shadow: 5px 5px 5px 5px rgba(0, 0, 0, 0.2);\n}\n.positionFixedBottom::-webkit-scrollbar {\n  width: 20px;\n}\n\n.positionFixedBottom::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\n.positionFixedBottom::-webkit-scrollbar-thumb {\n  background-color: #d6dee1;\n  border-radius: 20px;\n  border: 6px solid transparent;\n  background-clip: content-box;\n}\n.marcadorLateral {\n  min-width: 70px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.tituloProduto {\n  font-family: \"Nunito\";\n  font-style: Medium;\n  font-weight: 500;\n  font-size: 11px;\n  display: flex;\n  color: #343a40;\n}\n.fonteDistancia {\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n\n  color: #6c6e6f;\n}\n.tituloLateral {\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 13px;\n\n  color: #343a40;\n}\n.tituloRecargaDisponivel {\n  font-family: \"Nunito\";\n  font-style: SemiBold;\n  font-weight: 600;\n  font-size: 12px;\n\n  color: #343a40;\n}\n.textoEndereco {\n  font-family: \"Nunito\";\n  font-style: SemiBold;\n  font-weight: 600;\n  font-size: 12px;\n  padding-top: 5px;\n  color: #343a40;\n}\n#comoChegar {\n  background-color: #ff6600;\n  color: #fff;\n  font-family: \"Nunito\";\n  font-style: Medium;\n}\n#voltar {\n  background-color: #cdcdc1;\n  color: #343a40;\n  font-family: \"Nunito\";\n  font-style: Medium;\n}\n\n#detalhesLojas {\n  overflow-y: scroll;\n  max-height: 100px;\n}\n\n#detalhesLojas::-webkit-scrollbar {\n  width: 20px;\n}\n\n#detalhesLojas::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\n#detalhesLojas::-webkit-scrollbar-thumb {\n  background-color: #d6dee1;\n  border-radius: 20px;\n  border: 6px solid transparent;\n  background-clip: content-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
